import Vue from "vue";
import QRious from "qrious";

export default {
  printTicketVenta(sale) {
    // console.log(sale.company_img_url);

    const serie = sale.sales_document
    let facturaOrBoleta = false;
    if(serie == "FACTURA"){
      facturaOrBoleta = true;
    }

    let itemsProducts = ``;
    let logo_ticket = "";
    const link = sale.sale_link_pdf ? sale.sale_link_pdf : "";

    const qr = new QRious({
      value: link, // La URL o el texto
      size: 500,
      backgroundAlpha: 0, // 0 para fondo transparente
      foreground: "#000000", // Color del QR
      level: "H", // Puede ser L,M,Q y H (L es el de menor nivel, H el mayor)
    });

    const [date, hour] = sale.sales_date.split(" ");
    const [year, month, day] = date.split("-");
    const newDate = [day, month, year].join("-");

    let style = `<style type="text/css" media="screen, print">
    @import url('https://fonts.googleapis.com/css2?family=Karla:ital,wght@0,400;0,700;1,400;1,700&display=swap');
    @import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;700&display=swap');
    
    .voucher-content{ 
        font-family: 'Open Sans', sans-serif;
        font-size: 07px;
        margin-left: 5px;
        margin-right: 5px;
        
    }
    .ticket {
      width: 160px;
      max-width: 160px;
    }
    .border-div{
      border-top: 0.1px solid #ECECEC;
    }
    .border-general{
      border: 0.1px solid #ECECEC;
      border-radius: 5px;
    }
    .voucher-label{
      line-height: 0.8
    }
    .td-operation{
      width: 10%; 
      text-align: center;
    }
  </style>`;

    // ! reporte - ventas pdf
    if (sale.company_img_url) {
      logo_ticket = `<img class="imgCenter" src='/img/${sale.company_img_url}' height="47" width="130" />`;
    }

    let company_phone = "";
    if (sale.company_phone) {
      company_phone = `<span>${sale.company_phone}</span><br>`;
    }

    let type_document = "FACTURA DE VENTA ELECTRÓNICA";
    if (sale.sales_document === "BOLETA") {
      type_document = "BOLETA DE VENTA ELECTRÓNICA";
    } else if (sale.sales_document === "TICKET") {
      type_document = "TICKET DE VENTA ELECTRÓNICA";
    }

    let customer_address = "";
    if (sale.customer_address) {
      customer_address = sale.customer_address.toUpperCase();
    }

    let paymentMethod = "";
    if (sale.payment_method) {
      paymentMethod = sale.payment_method;
    }

    let payWith = "";
    if (paymentMethod == "EFECTIVO") {
      if (sale.pay_with > 0) {
        payWith = `
              <tr>
                <td style="width: 70%; text-align: right;">
                    <span class="voucher-label"><b>PAGA CON</b></span>
                </td>
                <td class="td-operation">
                  <span class="voucher-label"><b>S/</b></span>
                </td>
                <td style="width: 30%; text-align: right;">
                    <span class="voucher-label"><b> ${parseFloat(
                      sale.pay_with
                    ).toFixed(2)}</b></span>
                </td>
              </tr>
              <tr>
                <td style="width: 70%; text-align: right;">
                    <span class="voucher-label"><b>VUELTO</b></span>
                </td>
                <td class="td-operation">
                    <span class="voucher-label"><b>S/</b></span>
                </td>
                <td style="width: 30%; text-align: right;">
                    <span class="voucher-label"><b> ${parseFloat(
                      sale.change
                    ).toFixed(2)}</b></span>
                </td>
              </tr>
            `;
      }
    }
    //<label> ${sale.company_address}</label>
    let reporteCabecera = `
    <div style="display:flex; width:100%;">
      <div style="width: 45%; display:flex; align-items: center;">
        <img class="imgCenter" src='/img/${sale.company_img_url}' height="17" width="100%" />
      </div>
      <div style="display:flex; flex-direction:column; font-size:4.5px; padding-top:5px; width: 55%; padding-left:3px; text-align:end; ">
        <label style="font-weight: 900;">TOMOLAB S.A.C</label>
        <label>CAL.COLOMBIA NRO. 109
        URB. EL RECREO ET. 1 LA
        LIBERTAD - TRUJILLO</label>
      </div>
    </div>
    <div style="font-size:5px; display:flex; width:100%; margin-top: 5px; flex-direction: column;">  
      <div style="display:flex; width:100%;">
        <div style="display:flex; width:25%;">
          <label style="font-weight: 900;"> Sucursal </label>
        </div>
        <div style="display:flex; width:75%">
          <label>: ${sale.office_address}</label>
        </div>
      </div>
      <div style="display:flex; width:100%; margin-top: 3px;">
        <div style="display:flex; width:25%;">
          <label style="font-weight: 900;"> Telefono(s) </label>
        </div>
        <div style="display:flex; width:75%">
          <label>: ${sale.office_phone}</label>
        </div>
      </div>
    </div>

    <div style="display:flex; margin-top: 7px; font-weight: 900;">
      <label style="">RUC :  ${sale.company_ruc}</label>
    </div>

    <div style="">
      <span><b>${type_document}</b></span><br>
      <span><b>${sale.serie} - ${sale.correlative}</b></span><br><br>
    </div>

    `;

    //let items = [];
    sale.detail.forEach((el) => {
      let quantity = el.quantity.toString().padStart(3, "0");
      let name = el.description.trim();
      let value_subtotal = parseFloat(el.subtotal);
      let value_discount = 0;
      if (el.discount_value) {
        value_discount = parseFloat(el.discount_value);
      }
      let subtotal_item =
        Math.round((value_subtotal - value_discount) * 100) / 100;
      let subtotal = ` ${parseFloat(subtotal_item).toFixed(2)}`.padStart(
        30,
        " "
      );

      // itemsProducts += `<tr style="font-size:6px;">
      //             <td style="text-align: left; vertical-align: top;"><b>[${quantity}]</b></td>
      //             <td style="vertical-align: top; word-wrap: break-word !important;">${name}</td>
      //             <td style="text-align: right; vertical-align: top;">${parseFloat(
      //               el.price
      //             ).toFixed(2)}</td>
      //             <td style="text-align: right; vertical-align: top;">${subtotal}</td>
      //           </tr>`;

      itemsProducts += `
      <tr>
        <td style="text-align: left; vertical-align: top;" colspan="5">${name}</td>
      </tr>
      <tr style="">
        <td style="text-align: left; vertical-align: top;">${el.code}</td> 
        <td style="text-align: right; vertical-align: top;">${(parseFloat(el.price) /  1.18 ).toFixed(2) }</td> 
        <td style="text-align: right; vertical-align: top;">1</td> 
        <td style="text-align: right; vertical-align: top;">${subtotal}</td> 
        <td style="text-align: right; vertical-align: top;">UND</td> 
        <td style="text-align: right; vertical-align: top;">${(parseFloat(el.price) /  1.18 ).toFixed(2) }</td>           
      </tr>`;
    });

    //<span><b>HORA EMISION: </b>${Vue.prototype.$moment(sale.sales_date).format('HH:mm:ss a')}</span><br>
    //<span><b>MONEDA: </b>SOLES</span><br>
    //<span><b>IGV: </b>18.00</span><br>
    // new QRious({
    //   element: document.querySelector("#codigo"),
    //   value: "www.wost.pe", // La URL o el texto
    //   size: 200,
    //   backgroundAlpha: 0, // 0 para fondo transparente
    //   foreground: "#8bc34a", // Color del QR
    //   level: "H", // Puede ser L,M,Q y H (L es el de menor nivel, H el mayor)
    // });

    let metodoPago = "CONTADO";
    if (sale.credit_sale == true && sale.payment_method == null) {
      metodoPago = "CREDITO";
    }

    let namecliente = "";
    if (sale.client_name != null) {
      namecliente = sale.client_name;
    }

    let content = "";
    let fechaVenc = sale.sales_date;
    if (sale.credit_sale == true || sale.credit_sale == "true") {
      fechaVenc = sale.payment_date;
    }

    let campoObservacion = `
    <div style="padding: 5px 0px;">
      <b><label >Observacion</label></b>
      <div style="display:flex; width: 100%; height: 30px; background-color:white; margin-top:3px;" class="border-general">
        <label style="margin-left:2px; margin-top:2px;">
          ${sale.sale_observation}
        </label>
      </div>
    </div>
    `

    let metodo_de_pago_footer = `

      ${facturaOrBoleta == true  ? campoObservacion : "" }
      <span><b>METODO DE PAGO: </b>${paymentMethod}</span><br>
      <span><b>FORMA DE PAGO: </b>${metodoPago}</span><br>
    `

    // <label style="display:flex; text-align: center;"><b>TRANSFERENCIA GRATUITA DE UN BIEN O SERVICIO
    //   PRESTADO GRATUITAMENTE</b></label>
    //   <br>
    //   <label style="display:flex; text-align: center;">  Representación impresa de la BOLETA DE VENTA
    //   ELECTRÓNICA, para ver el documento visita </label>

    //   <label style="display:flex; text-align: center;"><b> https://wostsolutions.pse.pe/20606387670</b></label>
      
    //   <label style="display:flex; text-align: center;"> Emitido mediante un </label> 
      
    //   <label style="display:flex; text-align: center;"><b>PROVEEDOR Autorizado por la SUNAT</b></label> 

    //   <label style="display:flex; text-align: center;"> mediante Resolución de Intendencia </label>
      
    //   <label style="display:flex; text-align: center;"><b> </b></label>

    // <p style="display:flex; text-align: center;">
    //   Representación impresa de la BOLETA DE VENTA
    //   ELECTRÓNICA, para ver el documento visita
    //   <strong>https://wostsolutions.pse.pe/20606387670</strong>
    //   Emitido mediante un PROVEEDOR Autorizado por la
    //   SUNAT mediante Resolución de Intendencia No.034-005-
    //   0005315
    //   </p>

    // <label style="display:flex; justify-content:center; "> Emitido mediante un</label>
    //     <label style="display:flex; justify-content:center; font-weight: 700;"> PROVEEDOR Autorizado por la SUNAT</label>
    //     <label style="display:flex; justify-content:center; "> mediante Resolución de Intendencia</label>
    //     <label style="display:flex; justify-content:center; font-weight: 700;"> No.034-005-0005315</label>


    if(parseFloat(sale.total_gratuitas)>0){
      metodo_de_pago_footer = `
      <div style="display:flex; justify-content:center; flex-direction:column;">
        <label style="display:flex; text-align: center;"><b>TRANSFERENCIA GRATUITA DE UN BIEN O SERVICIO PRESTADO GRATUITAMENTE</b></label>
        <label style="display:flex; text-align: center;">  Representación impresa de la BOLETA DE VENTA ELECTRÓNICA, para ver el documento visita </label>
        <label style="display:flex; justify-content:center; font-weight: 700;"> https://wostsolutions.pse.pe/20606387670</label>

      </div>
      `;
    }

    let info_cliente = "";
    // if (
    //   (sale.is_client == false || sale.is_client == "false") &&
    //   (sale.empresa_name != null || sale.empresa_name != "")
    // ) {
    //   info_cliente = `<div>
    //     <span><b>CLIENTE</b></span><br>
    //     <span><b>RUC: </b> ${sale.company_ruc} </span>
    //     <br>
    //     <span>${sale.company_name ? sale.company_name.toUpperCase() : "" }</span><br>
    //     <span>${sale.office_address ? sale.office_address : ""}</span>
    //     <br>
    //   </div>`
    // }else if (sale.client_document != null && sale.client_name != null) {
    //   info_cliente = `<div>
    //       <span><b>CLIENTE</b></span><br>
    //       <span><b>RUC: </b> ${sale.client_document}
    //       </span>
    //       <br>
    //       <span>${namecliente.toUpperCase()}</span><br>
    //       <span>${sale.client_address}</span>
    //       <br>
    //   </div>`
    // }else {
    //   info_cliente = `<div>
    //     <span><b>CLIENTE</b></span><br>
    //     <span><b>${sale.customer_type_document}: </b> ${sale.customer_document}</span>
    //     <br>
    //     <span>${sale.customer_name ? sale.customer_name.toUpperCase() : "" }</span><br>
    //     <span>${customer_address}</span><br>
    //   </div>`
    // }

    if (
      (sale.is_client == false || sale.is_client == "false") &&
      (sale.empresa_name != null || sale.empresa_name != "")
    ) {
      info_cliente = `
        
        <div style="font-size:6px; display:flex; width:100%; flex-direction: column;">  
          <div style="display:flex; width:100%;">
            <div style="display:flex; width:25%;">
              <label style="font-weight: 900;"> Cliente </label>
            </div>
            <div style="display:flex; width:75%">
              <label>: ${
                sale.company_name ? sale.company_name.toUpperCase() : ""
              }</label>
            </div>
          </div>
          <div style="display:flex; width:100%; margin-top: 3px;">
            <div style="display:flex; width:25%;">
              <label style="font-weight: 900;"> RUC </label>
            </div>
            <div style="display:flex; width:75%">
              <label>: ${sale.company_ruc}</label>
            </div>
          </div>
          <div style="display:flex; width:100%; margin-top: 3px;">
            <div style="display:flex; width:25%;">
              <label style="font-weight: 900;"> DIRECCION </label>
            </div>
            <div style="display:flex; width:75%">
              <label>: ${
                sale.company_address ? sale.company_address : ""
              }</label>
            </div>
          </div>
        </div>
        `;
    } else if (sale.client_document != null && sale.client_name != null) {
      info_cliente = `
        
        <div style="font-size:6px; display:flex; width:100%;  flex-direction: column;">  
          <div style="display:flex; width:100%;">
            <div style="display:flex; width:25%;">
              <label style="font-weight: 900;"> Cliente </label>
            </div>
            <div style="display:flex; width:75%">
              <label>: ${namecliente.toUpperCase()}</label>
            </div>
          </div>
          <div style="display:flex; width:100%; margin-top: 3px;">
            <div style="display:flex; width:25%;">
              <label style="font-weight: 900;"> RUC </label>
            </div>
            <div style="display:flex; width:75%">
              <label>: ${sale.client_document}</label>
            </div>
          </div>
          <div style="display:flex; width:100%; margin-top: 3px;">
            <div style="display:flex; width:25%;">
              <label style="font-weight: 900;"> DIRECCION </label>
            </div>
            <div style="display:flex; width:75%">
              <label>: ${sale.client_address}</label>
            </div>
          </div>
        </div>
        `;
    } else {
      info_cliente = `
        
        <div style="font-size:6px; display:flex; width:100%;  flex-direction: column;">  
          <div style="display:flex; width:100%;">
            <div style="display:flex; width:25%;">
              <label style="font-weight: 900;"> Cliente </label>
            </div>
            <div style="display:flex; width:75%">
              <label>: ${
                sale.customer_name ? sale.customer_name.toUpperCase() : ""
              }</label>
            </div>
          </div>
          <div style="display:flex; width:100%; margin-top: 3px;">
            <div style="display:flex; width:25%;">
              <label style="font-weight: 900;"> ${
                sale.customer_type_document
              } </label>
            </div>
            <div style="display:flex; width:75%">
              <label>: ${sale.customer_document}</label>
            </div>
          </div>
          <div style="display:flex; width:100%; margin-top: 3px;">
            <div style="display:flex; width:25%;">
              <label style="font-weight: 900;"> DIRECCION </label>
            </div>
            <div style="display:flex; width:75%">
              <label>: ${customer_address}</label>
            </div>
          </div>
        </div>

        `;
    }

    let info_calcular = `<div>
        <span><b>FECHA EMISION: </b>${Vue.prototype
          .$moment(sale.sales_date)
          .format("DD/MM/YYYY")}</span><br>
        <span><b>FECHA VENC: </b>${Vue.prototype
          .$moment(fechaVenc)
          .format("DD/MM/YYYY")}</span><br>             
        <span><b>VENDEDOR: </b>${sale.seller_full_name.toUpperCase()}</span><br>
        <span><b>MONEDA:</b> SOLES</span><br>
        <span><b>TIPO DE CAMBIO</b></span><br>
        <span><b>IGV:</b> 18.00%</span>
        <br>
    </div>`;

    content = `      
    ${style}
    <div class="voucher-content ticket">
    ${reporteCabecera}

    ${info_cliente}

    <div style="width:100%; font-size:6px; margin-top:3px; margin-bottom:3px;">
      
      <div style="width:100%; display:flex; margin-bottom:1px;">
        <div style="width:45%; display:flex;">
          <div style="width: 40%;">
            <b>Moneda</b>
          </div>
          <div style="width: 60%;">
            <label> : SOL </label>
          </div>
        </div>
        <div style="width:55%; display:flex;">
          <div style="width: 50%;">
          <b>Fecha de</b>
          </div>
          <div style="width: 50%;">
          : ${newDate}
          </div>
        </div>
      </div>

      <div style="width:100%;  display:flex;">
        <div style="width:45%; display:flex;">
          <div style="width: 40%;">
          <b>Hora</b>
          </div>
          <div style="width: 60%;">
            <label> : ${hour} </label>
          </div>
        </div>

        <div style="width:55%; display:flex;">
          <div style="width: 50%;">
          <b>Atendido por</b>
          </div>
          <div style="width: 50%;">
          : ${sale.seller_first_name ? sale.seller_first_name[0] : " "}
          ${sale.seller_last_name ? sale.seller_last_name : ""}
          </div>
        </div>
      </div>

    </div>

        
            <table style="width: 100%; border-top: 0.1px solid #ECECEC; border-bottom: 0.1px solid #ECECEC;font-size: 5px; border-collapse: collapse;">
                <thead>
                    <tr>
                        <th style="text-align: left; width: 15%;">C. Sunat</th>
                        <th style="text-align: right; width: 25%;">Valor unitario</th>
                        <th style="text-align: right; width: 10%;">Cant.</th>
                        <th style="text-align: right; width: 20%;">P. Unitario</th>
                        <th style="text-align: right; width: 10%;">UM</th>
                        <th style="text-align: right; width: 20%;">Valor Total</th>
                    </tr>
                </thead>
                <tbody>
                    ${itemsProducts}
                </tbody>
            </table>
        <div>
            <table style="width: 100%;font-size: 5px; border-bottom: 1px solid #ECECEC;">
                <tbody>
                    <tr>
                        <td style="width: 70%; text-align: right;">
                            <span class="voucher-label"><b>OP. GRATUITAS</b></span>
                        </td>
                        <td class="td-operation">
                            <span class="voucher-label"><b>S/</b></span>
                        </td>
                        <td style="width: 30%; text-align: right;">
                            <span class="voucher-label"><b> ${parseFloat(
                              sale.total_gratuitas
                            ).toFixed(2)}</b></span>
                        </td>
                    </tr>
                    <tr>
                        <td style="width: 70%; text-align: right;">
                            <span class="voucher-label"><b>DESCUENTO (-)</b></span>
                        </td>
                        <td class="td-operation">
                            <span class="voucher-label"><b>S/</b></span>
                        </td>
                        <td style="width: 30%; text-align: right;">
                            <span class="voucher-label"><b> ${parseFloat(
                              sale.discount
                            ).toFixed(2)}</b></span>
                        </td>
                    </tr>
                    <tr>
                        <td style="width: 70%; text-align: right;">
                            <span class="voucher-label"><b>GRAVADAS</b></span>
                        </td>
                        <td class="td-operation">
                            <span class="voucher-label"><b>S/</b></span>
                        </td>
                        <td style="width: 30%; text-align: right;">
                            <span class="voucher-label"><b> ${parseFloat(
                              sale.subtotal
                            ).toFixed(2)}</b></span>
                        </td>
                    </tr>
                    
                    
                    <tr>
                        <td style="width: 70%; text-align: right;">
                            <span class="voucher-label"><b>IGV</b></span>
                        </td>
                        <td class="td-operation">
                            <span class="voucher-label"><b>S/</b></span>
                        </td>
                        <td style="width: 30%; text-align: right;">
                            <span class="voucher-label"><b> ${parseFloat(
                              sale.igv
                            ).toFixed(2)}</b></span>
                        </td>
                    </tr>
                    <tr>
                      <td style="width: 70%; text-align: right;">
                          <span class="voucher-label"><b>REDONDEO</b></span>
                      </td>
                      <td class="td-operation">
                            <span class="voucher-label"><b>S/</b></span>
                        </td>
                      <td style="width: 30%; text-align: right;">
                          <span class="voucher-label"><b> ${parseFloat(
                            sale.rounding
                          ).toFixed(2)}</b></span>
                      </td>
                    </tr>
                    <tr>
                        <td style="width: 70%; text-align: right;">
                            <span class="voucher-label"><b>TOTAL</b></span>
                        </td>
                        <td class="td-operation">
                            <span class="voucher-label"><b>S/</b></span>
                        </td>
                        <td style="width: 20%; text-align: right;">
                            <span class="voucher-label"><b> ${parseFloat(
                              sale.total_rounded
                            ).toFixed(2)}</b></span>
                        </td>
                    </tr>
                    ${payWith}
                    <tr>
                        <td colspan="2">
                            <br>
                            <span><i><b>SON: ${this.NumerosaLetras(
                              parseFloat(sale.total_rounded).toFixed(2)
                            ).toUpperCase()} SOLES</b></i></span>
                        </td>
                    </tr>
                    
                </tbody>
            </table>
        </div>
        <div style="font-size:6px;">
          ${metodo_de_pago_footer}
          
          <div style="display:flex; justify-content:center; width:100%; margin:5px 0; flex-direction: column; align-items: center;">
            <div style="display:flex; width:35px; height:35px;">
              <img src="${
                qr.image.src
              }" style="width: 100%; height: 100%;"></img>
            </div>
            <label style="margin-top:3px; font-size:5px; display:flex; justify-content:center;">Representación Impresa de la ${type_document}</label>
          </div>
          <div class="border-div"></div>
          
            
        </div>
        <br>
        <br>
        <br>
    </div>`;

    // <p style=" text-align:center;" >
    //         Emitido mediante un <strong> PROVEEDOR Autorizado por la SUNAT </strong>
    //         mediante Resolución de Intendencia No. <b>034-005-0005315 </b>
    //       </p>

    // <label style="display:flex; text-align:center;">Emitido mediante un </label><label>PROVEEDOR Autorizado por la SUNAT </label><label> mediante Resolución de Intendencia No. <b>034-005-0005315 </b></label>
    return content;
  },



  printWorkOrder(sale) {
    // console.log(sale);
    let itemsProducts = ``;
    let logo_ticket = "";
    // ! solicitud de analisis pdf
    if (sale.company_img_url) {
      logo_ticket = `<img class="imgCenter" src='/img/${sale.company_img_url}' height="90" width="200" />`;
    }

    let company_phone = "";
    if (sale.company_phone) {
      company_phone = `<span>${sale.company_phone}</span><br>`;
    }

    //let type_document = 'FACTURA ELECTRÓNICA';
    //if (sale.sales_document === 'BOLETA') {
    let type_document = "ORDEN DE TRABAJO";
    //} else if (sale.sales_document === 'TICKET') {
    //type_document = 'TICKET DE VENTA';
    //}

    let customer_address = "";
    if (sale.customer_address) {
      customer_address = sale.customer_address.toUpperCase();
    }

    let customer_born_date = "";
    if (sale.customer_born_date) {
      customer_born_date = sale.customer_born_date.toUpperCase();
    }
    let customer_gender = "";
    if (sale.gender) {
      customer_gender = sale.gender.toUpperCase();
    }

    let paymentMethod = "";
    if (sale.payment_method) {
      paymentMethod = sale.payment_method;
    }

    let doctorName = "";
    if (sale.doctor_name) {
      doctorName = sale.doctor_name.toUpperCase();
    }

    let payWith = "";
    if (paymentMethod == "EFECTIVO") {
      if (sale.pay_with > 0) {
        payWith = `
              <tr>
                <td style="width: 70%; text-align: left;">
                    <span class="voucher-label"><b>PAGA CON</b></span>
                </td>
                <td style="width: 30%; text-align: right;">
                    <span class="voucher-label"><b>S/ ${parseFloat(
                      sale.pay_with
                    ).toFixed(2)}</b></span>
                </td>
              </tr>
              <tr>
                <td style="width: 70%; text-align: left;">
                    <span class="voucher-label"><b>VUELTO</b></span>
                </td>
                <td style="width: 30%; text-align: right;">
                    <span class="voucher-label"><b>S/ ${parseFloat(
                      sale.change
                    ).toFixed(2)}</b></span>
                </td>
              </tr>
            `;
      }
    }

    sale.detail.forEach((el) => {
      let quantity = el.quantity.toString().padStart(3, "0");
      let name = el.description;
      let product_code = el.code;
      let value_subtotal = parseFloat(el.subtotal);
      let value_discount = 0;
      if (el.discount_value) {
        value_discount = parseFloat(el.discount_value);
      }
      let subtotal_item =
        Math.round((value_subtotal - value_discount) * 100) / 100;
      let subtotal = `S/. ${parseFloat(subtotal_item).toFixed(2)}`.padStart(
        30,
        " "
      );
      const respalda = `
      <td align="center">
        ${logo_ticket}
      </td>
      <td align="center">
        <h1>ORDEN DE TRABAJO</h1>
        <h4>N° Orden: ${sale.order_code}</h4>
      </td>`;
      itemsProducts += `<tr>
                <td style="text-align: left; vertical-align: top;">${product_code}</td>
                <td style="vertical-align: top; word-wrap: break-word !important;">${name}</td>
            </tr>`;
    });
    // console.log(sale);
    function calcularEdad(fecha) {
      var hoy = new Date();
      var cumpleanos = new Date(fecha);
      var edad = hoy.getFullYear() - cumpleanos.getFullYear();
      var m = hoy.getMonth() - cumpleanos.getMonth();

      if (m < 0 || (m === 0 && hoy.getDate() < cumpleanos.getDate())) {
        edad--;
      }

      return edad;
    }
    // console.log(sale.customer_born_date);
    let content = `        
          <style type="text/css" media="screen, print">
            @import url('https://fonts.googleapis.com/css2?family=Karla:ital,wght@0,400;0,700;1,400;1,700&display=swap');
        
            @import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;700&display=swap');
            
            .voucher-content{ 
                font-family: 'Open Sans', sans-serif;
                font-size: 10px;
                margin-left: 0px;
                margin-right: 0px;
            }
          </style>
        
        <div class="voucher-content">
        
        <table style="width: 100%; border-top: 2px solid; border-bottom: 2px solid;font-size: 10px; border-collapse: collapse;border:1px">
            <tr>
              <td align="center">
              ${logo_ticket}
            </td>
            <td align="center">
            <div style="position: relative; top:80px;">
            <h1>ORDEN DE TRABAJO</h1>
            <h4>N° Orden: ${sale.order_code}</h4>
            </div>
            </td>
              <td align="center">
                Fecha: ${Vue.prototype
                  .$moment(sale.sales_date)
                  .format("DD/MM/YYYY HH:mm:ss")} <br>
                Sede: <span><b>${sale.company_name}</b></span><br>
                <span><b>${sale.company_ruc}</b></span><br>
                <span>${sale.office_address}</span><br>
                
              </td>
            </tr>
        </table>
        <br><br><br><br><br><br>
        <div style ="float:right; margin-right:10px; font-size: 11px;" ><b>${
          sale.office_name
        }</b></div>
        <table style="width: 100%; margin-top: 10px solid;font-size: 10px; border:2px solid rgb(2, 49, 69)">
        <tr>
            <td>Paciente: ${sale.customer_name.toUpperCase()}</td>
            <td>DNI: ${sale.customer_document}</td>
            <td>Sexo: ${customer_gender}</td>
            <td>Fecha Nac: ${Vue.prototype
              .$moment(customer_born_date)
              .format("DD/MM/YYYY")}</td>
            <td>Edad: ${calcularEdad(sale.customer_born_date)}</td>
        </tr>
        <tr>
            <td>Médico: ${doctorName}</td>
            <td>Telefono: ${sale.customer_phone}</td>
            <td></td>
            <td></td>
            <td></td> 
        </tr>
        <tr>
            <td>Cliente: ${sale.client_name ? sale.client_name : ""}</td>
            <td>Ruc: ${sale.client_document ? sale.client_document : ""}</td>
            <td>Telefono: ${sale.client_phone ? sale.client_phone : ""}</td>
            <td></td>
            <td></td> 
        </tr>
        <tr>
            <td>Empresa: ${sale.empresa_name ? sale.empresa_name : ""}</td>
            <td>Ruc: ${sale.empresa_ruc ? sale.empresa_ruc : ""}</td>
            <td>Telefono: ${sale.empresa_phone ? sale.empresa_phone : ""}</td>
            <td></td>
            <td></td> 
        </tr>
        </table>

        <div>
            <table style="width: 100%;margin-top:20px; border-top: 2px solid rgb(2, 49, 69); border-bottom: 2px solid rgb(2, 49, 69);font-size: 10px; border-collapse: collapse;">
                <thead>
                    <tr>
                        <th style="text-align: left; width: 10%;">COD</th>
                        <th style="text-align: left; width: 40%;">DESCRIPCION</th>

                    </tr>
                </thead>
                <tbody>
                    ${itemsProducts}
                </tbody>
            </table>
        </div>

        </div>`;

    return content;
  },

  printTicketCotizacion(sale) {
    // console.log(sale);
    let itemsProducts = ``;
    let logo_ticket = "";
    if (sale.company_img_url) {
      logo_ticket = `<img class="imgCenter" src='/img/${sale.company_img_url}' height="90px" width="160px" />`;
    }

    let company_phone = "";
    if (sale.company_phone) {
      company_phone = `<span>${sale.company_phone}</span><br>`;
    }

    let customer_address = "";
    if (sale.customer_address) {
      customer_address = sale.customer_address.toUpperCase();
    }

    let customer_born_date = "";
    if (sale.customer_born_date) {
      customer_born_date = sale.customer_born_date.toUpperCase();
    }
    let customer_gender = "";
    if (sale.gender) {
      customer_gender = sale.gender.toUpperCase();
    }

    let paymentMethod = "";
    if (sale.payment_method) {
      paymentMethod = sale.payment_method;
    }

    let companyName = "";
    if (sale.company_name) {
      companyName = sale.company_name.toUpperCase();
    }
    let companyRuc = "";
    if (sale.company_ruc) {
      companyRuc = sale.company_ruc.toUpperCase();
    }

    let payWith = "";
    if (paymentMethod == "EFECTIVO") {
      if (sale.pay_with > 0) {
        payWith = `
              <tr>
                <td style="width: 70%; text-align: left;">
                    <span class="voucher-label"><b>PAGA CON</b></span>
                </td>
                <td style="width: 30%; text-align: right;">
                    <span class="voucher-label"><b>S/ ${parseFloat(
                      sale.pay_with
                    ).toFixed(2)}</b></span>
                </td>
              </tr>
              <tr>
                <td style="width: 70%; text-align: left;">
                    <span class="voucher-label"><b>VUELTO</b></span>
                </td>
                <td style="width: 30%; text-align: right;">
                    <span class="voucher-label"><b>S/ ${parseFloat(
                      sale.change
                    ).toFixed(2)}</b></span>
                </td>
              </tr>
            `;
      }
    }
    let total_dcto = 0.0;
    sale.detail.forEach((el) => {
      let quantity = el.quantity.toString().padStart(3, "0");
      let name = el.description;
      let price = `S/. ${parseFloat(el.price).toFixed(2)}`.padStart(30, " ");
      let value_subtotal = parseFloat(el.subtotal);
      let value_discount = 0;

      if (el.discount) {
        value_discount = parseFloat(el.discount);
        total_dcto = total_dcto + el.discount;
      }
      let subtotal_item =
        Math.round((value_subtotal - value_discount) * 100) / 100;
      let subtotal = `S/. ${parseFloat(subtotal_item).toFixed(2)}`.padStart(
        30,
        " "
      );

      itemsProducts += `<tr>
                
                
                <td style="text-align: left; vertical-align: top;">${quantity}</td>
                <td style="vertical-align: top; word-wrap: break-word !important;">${name}</td>
                <td style="text-align: right; vertical-align: top;">${price}</td>
                <td style="text-align: right; vertical-align: top;">S/. ${value_discount}</td>
                <td style="text-align: right; vertical-align: top;">${subtotal}</td>
            </tr>`;
    });

    const calcularEdad = (fecha) => {
      var hoy = new Date();
      var cumpleanos = new Date(fecha);
      var edad = hoy.getFullYear() - cumpleanos.getFullYear();
      var m = hoy.getMonth() - cumpleanos.getMonth();

      if (m < 0 || (m === 0 && hoy.getDate() < cumpleanos.getDate())) {
        edad--;
      }

      return edad;
    };
    const edad = calcularEdad(sale.customer_born_date)
    total_dcto = `S/. ${parseFloat(total_dcto).toFixed(2)}`;
    let subtotal = `S/. ${parseFloat(sale.subtotal).toFixed(2)}`.padStart(
      30,
      " "
    );
    let igv = `S/. ${parseFloat(sale.igv).toFixed(2)}`.padStart(30, " ");
    let total = `S/. ${parseFloat(sale.total).toFixed(2)}`.padStart(30, " ");

    //     <tr>
    //     <td>Paciente: ${sale.customer_name.toUpperCase()}</td>
    //     <td>DNI: ${sale.customer_document}</td>
    //     <td>Sexo: ${customer_gender}</td>
    //     <td>Fecha Nac: ${Vue.prototype
    //       .$moment(customer_born_date)
    //       .format("DD/MM/YYYY")}</td>
    //     <td>Edad: 34</td>
    // </tr>
    // <tr>
    //     <td>Razón Social: ${companyName || ""}</td>
    //     <td>RUC: ${companyRuc || ""}</td>
    //     <td></td>
    //     <td></td>
    //     <td></td>
    // </tr>

    let content = `        
          <style type="text/css" media="screen, print">
            @import url('https://fonts.googleapis.com/css2?family=Karla:ital,wght@0,400;0,700;1,400;1,700&display=swap');
        
            @import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;700&display=swap');
            
            .voucher-content{ 
                font-family: 'Open Sans', sans-serif;
                font-size: 10px;
                margin-left: 0px;
                margin-right: 0px;
            }
          </style>
        
        <div class="voucher-content">
        
        <table style="width: 100%; border-top: 2px solid; border-bottom: 2px solid;font-size: 10px; border-collapse: collapse;border:1px">
            <tr>
              <td align="center">
                ${logo_ticket}
              </td>
              <td align="center">
                <h1>COTIZACION</h1>
                <h4>Código: 00${sale.id}</h4>
              </td>
              <td align="center">
                Fecha: ${Vue.prototype
                  .$moment(sale.sales_date)
                  .format("DD/MM/YYYY HH:mm:ss")} <br>
                Sede: <span><b>${sale.companiesOwnername}</b></span><br>
                <span><b>${sale.companiesOwnerphone}</b></span><br>
                <span>${sale.companiesOwneaddress}</span><br>
              </td>
            </tr>
        </table>
        <br><br>
        <table style="width: 100%; margin-top: 10px solid;font-size: 9px; border:2px solid rgb(2, 49, 69)">
       
        <tr>
          <td>Cliente: ${sale.client_name || sale?.customer_name?.toUpperCase() 
            }</td>
          <td>RUC/DNI: ${sale.client_ruc || sale?.customer_document?.toUpperCase() 
            }</td>
            <td>Sexo: ${customer_gender}</td>
            <td>Fecha Nac: ${sale.customer_born_date}</td>
            <td>Edad: ${edad}</td>
          </tr>
        </table>

        <div>
            <table style="width: 100%;margin-top:20px; border-top: 2px solid rgb(2, 49, 69); border-bottom: 2px solid rgb(2, 49, 69);font-size: 10px; border-collapse: collapse;">
                <thead>
                    <tr>
                        <th style="text-align: left; width: 10%;">CANTIDAD</th>
                        <th style="text-align: left; width: 40%;">DESCRIPCION</th>
                        <th style="text-align: right; width: 10%;">PRECIO</th>
                        <th style="text-align: right; width: 10%;">DESCUENTO</th>
                        <th style="text-align: right; width: 10%;">SUBTOTAL</th>

                    </tr>
                </thead>
                <tbody>
                    ${itemsProducts}
                </tbody>
                <tfoot>
                <tr>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th style="text-align: right;">DESCUENTO</th>
                  <th style="text-align: right;">S/. ${sale.discount}</th>
                </tr>
                <tr>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th style="text-align: right;">SUBTOTAL</th>
                  <th style="text-align: right;">${subtotal}</th>
                </tr>
                <tr>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th style="text-align: right;">IGV</th>
                  <th style="text-align: right;">${igv}</th>
                </tr>
                <tr>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th style="text-align: right;">TOTAL</th>
                  <th style="text-align: right;">${total}</th>
                </tr>

                </tfoot>
            </table>
        </div>

        </div>`;

    return content;
  },

  NumerosaLetras(cantidad) {
    var numero = 0;
    cantidad = parseFloat(cantidad);

    if (cantidad == "0.00" || cantidad == "0") {
      return "CERO con 00/100 ";
    } else {
      var ent = cantidad.toString().split(".");
      var arreglo = this.separar_split(ent[0]);
      var longitud = arreglo.length;

      switch (longitud) {
        case 1:
          numero = this.unidades(arreglo[0]);
          break;
        case 2:
          numero = this.decenas(arreglo[0], arreglo[1]);
          break;
        case 3:
          numero = this.centenas(arreglo[0], arreglo[1], arreglo[2]);
          break;
        case 4:
          numero = this.unidadesdemillar(
            arreglo[0],
            arreglo[1],
            arreglo[2],
            arreglo[3]
          );
          break;
        case 5:
          numero = this.decenasdemillar(
            arreglo[0],
            arreglo[1],
            arreglo[2],
            arreglo[3],
            arreglo[4]
          );
          break;
        case 6:
          numero = this.centenasdemillar(
            arreglo[0],
            arreglo[1],
            arreglo[2],
            arreglo[3],
            arreglo[4],
            arreglo[5]
          );
          break;
      }

      ent[1] = isNaN(ent[1]) ? "00" : ent[1];

      if (ent[1].length == 1) {
        ent[1] = ent[1] + "0";
      }

      return numero.trim() + " con " + ent[1] + "/100";
    }
  },

  unidades(unidad) {
    if (unidad == 0) {
      return "CERO";
    } else {
      let unidades = Array(
        "UN ",
        "DOS ",
        "TRES ",
        "CUATRO ",
        "CINCO ",
        "SEIS ",
        "SIETE ",
        "OCHO ",
        "NUEVE "
      );

      return unidades[unidad - 1];
    }
  },

  decenas(decena, unidad) {
    let diez = Array(
      "ONCE ",
      "DOCE ",
      "TRECE ",
      "CATORCE ",
      "QUINCE",
      "DIECISEIS ",
      "DIECISIETE ",
      "DIECIOCHO ",
      "DIECINUEVE "
    );
    let decenas = Array(
      "DIEZ ",
      "VEINTE ",
      "TREINTA ",
      "CUARENTA ",
      "CINCUENTA ",
      "SESENTA ",
      "SETENTA ",
      "OCHENTA ",
      "NOVENTA "
    );

    if (decena == 0 && unidad == 0) {
      return "";
    }

    if (decena == 0 && unidad > 0) {
      return this.unidades(unidad);
    }

    if (decena == 1) {
      if (unidad == 0) {
        return decenas[decena - 1];
      } else {
        return diez[unidad - 1];
      }
    } else if (decena == 2) {
      if (unidad == 0) {
        return decenas[decena - 1];
      } else if (unidad == 1) {
        let veinte = "";
        return (veinte = "VEINTI" + "UNO");
      } else {
        let veinte = "";
        return (veinte = "VEINTI" + this.unidades(unidad));
      }
    } else {
      if (unidad == 0) {
        return decenas[decena - 1] + " ";
      }
      if (unidad == 1) {
        return decenas[decena - 1] + " Y " + "UNO";
      }

      return decenas[decena - 1] + " Y " + this.unidades(unidad);
    }
  },

  centenas(centena, decena, unidad) {
    let centenas = Array(
      "CIENTO ",
      "DOSCIENTOS ",
      "TRESCIENTOS ",
      "CUATROCIENTOS ",
      "QUINIENTOS ",
      "SEISCIENTOS ",
      "SETECIENTOS ",
      "OCHOCIENTOS ",
      "NOVECIENTOS "
    );

    if (centena == 0 && decena == 0 && unidad == 0) {
      return "";
    }
    if (centena == 1 && decena == 0 && unidad == 0) {
      return "CIEN ";
    }

    if (centena == 0 && decena == 0 && unidad > 0) {
      return this.unidades(unidad);
    }

    if (decena == 0 && unidad == 0) {
      return centenas[centena - 1] + "";
    }

    if (decena == 0) {
      var numero = centenas[centena - 1] + "" + this.decenas(decena, unidad);
      return numero.replace(" Y ", " ");
    }
    if (centena == 0) {
      return this.decenas(decena, unidad);
    }

    return centenas[centena - 1] + "" + this.decenas(decena, unidad);
  },

  unidadesdemillar(unimill, centena, decena, unidad) {
    let numero =
      this.unidades(unimill) + " MIL " + this.centenas(centena, decena, unidad);
    numero = numero.replace("UN  MIL ", "MIL ");
    if (unidad == 0) {
      return numero.replace(" Y ", " ");
    } else {
      return numero;
    }
  },

  decenasdemillar(decemill, unimill, centena, decena, unidad) {
    let numero =
      this.decenas(decemill, unimill) +
      " MIL " +
      this.centenas(centena, decena, unidad);
    return numero;
  },

  centenasdemillar(centenamill, decemill, unimill, centena, decena, unidad) {
    let numero = 0;
    numero =
      this.centenas(centenamill, decemill, unimill) +
      " MIL " +
      this.centenas(centena, decena, unidad);

    return numero;
  },

  separar_split(texto) {
    let contenido = new Array();
    for (var i = 0; i < texto.length; i++) {
      contenido[i] = texto.substr(i, 1);
    }
    return contenido;
  },
};
